import React, { FC, useEffect } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { AppBar, Tabs, Tab, Typography, Box, Grid } from "@material-ui/core";
import { getFixedFlg } from "../../Header/Header";
import OneVisionTable, {
  getChangeFlg,
  getApproveDay,
  getAgreementDay,
  getRegulationDay,
  isApproveDate,
} from "./OneVisionTable";
import OneVisionResultGraphs from "./OneVisionResultGraphs";
import OneVisionResultGraphs2 from "./OneVisionResultGraphs2";
import OneVisionResultPrint from "./OneVisionResultPrint";
import OneVisionDialog from "../OneVisionDialog";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

interface LinkTabProps {
  label?: string;
  href?: string;
}

function LinkTab(props: LinkTabProps) {
  return (
    <Tab
      component="a"
      onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
      }}
      {...props}
      style={{
        fontSize: "20px",
      }}
    />
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  contentFrame: {
    overflowY: "auto",
    height: "68vh",
    // iPad縦
    "@media (min-width: 830px)": {
      height: "78vh",
    },
    // iPad横
    "@media (min-width: 1100px)": {
      height: "72vh",
    },
    // GWPC
    "@media (min-width: 1300px)": {
      height: "67vh",
    },
  }
}));

const OneVisionTab: FC<{
  tenpoCode: string;
  oneVisionId: string;
  lastOneVisionId: string;
  setUpdateFlg: any;
}> = ({ tenpoCode, oneVisionId, lastOneVisionId, setUpdateFlg }) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [dialogMessage, setDialogMessage] = React.useState<any[]>([]);
  const [dialogFlg, setDialogFlg] = React.useState(false);

  const dialogClose = () => {
    setDialogFlg(false);
  };

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    if (getChangeFlg()) {
      setDialogMessage(["保存されていません。保存ボタンを押してください。"]);
      setDialogFlg(true);
      return;
    }
    if (!getChangeFlg() && newValue !== 0) {
      if (!getFixedFlg() && isApproveDate() === 0) {
        setDialogMessage(["作成日に前回作成日以降の日付を入力してください"]); //旧承認日
        setDialogFlg(true);
        return;
      }
      if (!getFixedFlg() && isApproveDate() === -1) {
        setDialogMessage(["作成日に正しい日付を入力してください"]); //旧承認日
        setDialogFlg(true);
        return;
      }
    }
    if (newValue !== 0) {
      let errorMessage: String[] = [];
      if (!getApproveDay()) {
        errorMessage.push("・作成日");
      }
      if (!getAgreementDay()) {
        errorMessage.push("・三六協定");
      }
      if (!getRegulationDay()) {
        errorMessage.push("・就業規則");
      }
      if (errorMessage && errorMessage.length !==0) {
        let message = ["以下を入力してください"];
        errorMessage.forEach(function (str) {
          message.push(String(str));
        });
        setDialogMessage(message);
        setDialogFlg(true);
        return;
      }
    }
    setValue(newValue);
  };

  useEffect(() => {
    setValue(0);
  }, [tenpoCode]);

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          variant="fullWidth"
          value={value}
          onChange={handleChange}
          TabIndicatorProps={{
            style: {
              backgroundColor: "#37ab9d",
              height: "10px",
            },
          }}
          style={{
            backgroundColor: "#f2f2f2",
            color: "#3e3e3e",
          }}
        >
          <LinkTab label="チェック" href="/check" {...a11yProps(0)} />
          <LinkTab label="集計" href="/summery" {...a11yProps(1)} />
          <LinkTab label="提出（印刷）" href="/print" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <OneVisionTable
          tenpoCode={tenpoCode}
          oneVisionId={oneVisionId}
          lastOneVisionId={lastOneVisionId}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
      <Grid container className={classes.contentFrame} >
        <OneVisionResultGraphs
          tenpoCode={tenpoCode}
          oneVisionId={oneVisionId}
          lastOneVisionId={lastOneVisionId}
        />
        <OneVisionResultGraphs2
          tenpoCode={tenpoCode}
          oneVisionId={oneVisionId}
          lastOneVisionId={lastOneVisionId}
        />
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <OneVisionResultPrint
          tenpoCode={tenpoCode}
          oneVisionId={oneVisionId}
          lastOneVisionId={lastOneVisionId}
          setUpdateFlg={setUpdateFlg}
        />
      </TabPanel>

      <OneVisionDialog
        msg={dialogMessage}
        isOpen={dialogFlg}
        doOK={dialogClose}
        doNo={dialogClose}
        isAlert={true}
      />
    </div>
  );
};

export default OneVisionTab;
